import { render, staticRenderFns } from "./FlowDetail.vue?vue&type=template&id=34692689&scoped=true&"
import script from "./FlowDetail.vue?vue&type=script&lang=js&"
export * from "./FlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./FlowDetail.vue?vue&type=style&index=0&id=34692689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34692689",
  null
  
)

export default component.exports